module.exports = __webpack_public_path__ + "img/setmeal.e1c60231.svg";